import { createContext } from 'react';

const WebAppContext = createContext();

export default WebAppContext;
